__turbopack_context__.v({
  "helios-page-hero": "Vxf3Va_helios-page-hero",
  "helios-page-hero--media-spacing-flush": "Vxf3Va_helios-page-hero--media-spacing-flush",
  "helios-page-hero--surface-dark": "Vxf3Va_helios-page-hero--surface-dark",
  "helios-page-hero__banner": "Vxf3Va_helios-page-hero__banner",
  "helios-page-hero__banner--height-content": "Vxf3Va_helios-page-hero__banner--height-content",
  "helios-page-hero__banner--height-floating": "Vxf3Va_helios-page-hero__banner--height-floating",
  "helios-page-hero__banner--overlay-leftFade": "Vxf3Va_helios-page-hero__banner--overlay-leftFade",
  "helios-page-hero__banner--overlay-scrim": "Vxf3Va_helios-page-hero__banner--overlay-scrim",
  "helios-page-hero__caption": "Vxf3Va_helios-page-hero__caption",
  "helios-page-hero__container": "Vxf3Va_helios-page-hero__container",
  "helios-page-hero__container--full": "Vxf3Va_helios-page-hero__container--full",
  "helios-page-hero__content": "Vxf3Va_helios-page-hero__content",
  "helios-page-hero__content--placement-lead": "Vxf3Va_helios-page-hero__content--placement-lead",
  "helios-page-hero__content--placement-split": "Vxf3Va_helios-page-hero__content--placement-split",
  "helios-page-hero__content--tone-inverse": "Vxf3Va_helios-page-hero__content--tone-inverse",
  "helios-page-hero__image": "Vxf3Va_helios-page-hero__image",
  "helios-page-hero__image--desktop": "Vxf3Va_helios-page-hero__image--desktop",
  "helios-page-hero__image--mobile": "Vxf3Va_helios-page-hero__image--mobile",
  "helios-page-hero__image-frame": "Vxf3Va_helios-page-hero__image-frame",
  "helios-page-hero__image-frame--has-mobile": "Vxf3Va_helios-page-hero__image-frame--has-mobile",
  "helios-page-hero__image-frame--portrait": "Vxf3Va_helios-page-hero__image-frame--portrait",
  "helios-page-hero__image-frame--square": "Vxf3Va_helios-page-hero__image-frame--square",
  "helios-page-hero__media": "Vxf3Va_helios-page-hero__media",
  "helios-page-hero__media--placement-bleed": "Vxf3Va_helios-page-hero__media--placement-bleed",
  "helios-page-hero__media--placement-split": "Vxf3Va_helios-page-hero__media--placement-split",
  "helios-page-hero__overlay": "Vxf3Va_helios-page-hero__overlay",
  "helios-page-hero__split": "Vxf3Va_helios-page-hero__split",
  "helios-page-hero__split--contained": "Vxf3Va_helios-page-hero__split--contained",
  "helios-page-hero__split--media-first-mobile": "Vxf3Va_helios-page-hero__split--media-first-mobile",
});
